import Apps from "@/modules/Apps/pages/Index";

export default [
  {
    name: "apps",
    path: "/apps",
    component: Apps,
    meta: {
      title: "Apps",
      clienteNutsDiretoOnly: true,
    },
  },
];
